<template>
    <div class="table-container">
        <div class="table-hader-title">
            <h2>~安くて即日対応可能！~<br>給湯器業者BEST5の比較</h2>
        </div>
        <p class="scroll-text"><span class="blink">横にスクロールできます▶︎</span></p>
        <div class="table-wrapper">
            <table class="vendor-table">
                <thead>
                    <tr>
                        <th class="header-cell fixed-column"></th>

                        <th class="header-cell vendor-column vendor-1">
                            <div class="ranking-badge no-1"><span>No.1</span></div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-4-1.png" alt="">
                                <p class="vendor-name">お湯が出ない.com</p>
                            </div>
                        </th>

                        <th class="header-cell vendor-column vendor-2">
                            <div class="ranking-badge no-2"><span>No.2</span></div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-1.png" alt="">
                                <p class="vendor-name">給湯器駆けつけ隊</p>
                            </div>
                        </th>

                        <th class="header-cell vendor-column vendor-3">
                            <div class="ranking-badge no-3"><span>No.3</span></div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-6.png" alt="">
                                <p class="vendor-name">チカラもち</p>
                            </div>
                        </th>

                        <th class="header-cell vendor-column vendor-3">
                            <div class="ranking-badge no-3"><span>No.3</span></div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-3.png" alt="">
                                <p class="vendor-name">街角給湯相談所</p>
                            </div>
                        </th>

                        <th class="header-cell vendor-column vendor-4">
                            <div class="ranking-badge no-4"><span>No.4</span></div>
                            <div class="vendor-info">
                                <img src="../../assets/rank-table/vendor-5-1.png" alt="">
                                <p class="vendor-name">給湯お助けたい</p>
                            </div>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <th class="fixed-column">総合評価</th>
                        <td class="data-cell rank-1">
                            <span class="number"><span class="bold-red under-yellow">4.8</span></span><br>
                            <span class="hoshi">★★★★★</span>
                        </td>
                        <td class="data-cell">
                            <span class="number"><span class="bold-font">4.4</span></span><br>
                            <span class="normal">★★★★</span>
                        </td>
                        <td class="data-cell">
                            <p><span class="number"><span class="bold-font">4.2</span></span><br><span class="normal">★★★★</span></p>
                        </td>
                        <td class="data-cell">
                            <span class="number"><span class="bold-font">4.1</span></span><br><span class="normal">★★★★</span>
                        </td>
                        <td class="data-cell">
                            <span class="number"><span class="bold-font">3.9</span></span><br><span class="normal">★★★★</span>
                        </td>
                    </tr>
                    <tr>
                        <th class="fixed-column">修理対応</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p class="bold-red">修理対応可能</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">交換のみ</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">交換のみ</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">交換のみ</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">交換のみ</p>
                        </td>
                    </tr>

                    <tr>
                        <th class="fixed-column">本体<br>最大割引</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p class="bold-red">最大84%OFF</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">最大91%OFF</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">最大82%OFF</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">最大92%OFF</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">最大80%OFF</p>
                        </td>
                    </tr>

                    <tr>
                        <th class="fixed-column">対応<br>スピード</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p><span class="bold-font">即日対応OK</span><br><span class="bold-red">最短30分で駆けつけ</span></p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">即日対応OK<br>最短30分で駆けつけ</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">最短当日OK</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">即日対応OK<br>最短30分で駆けつけ</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">最短当日OK</p>
                        </td>
                    </tr>

                    <tr>
                        <th class="fixed-column">保証</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p class="bold-red">工事10年<br>商品7年</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">工事10年<br>商品10年</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">工事10年<br>商品10年</p>
                        </td>
                        <td class="data-cell">
                            <div class="triangle"></div>
                            <p class="bold-font">工事10年</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">工事10年<br>商品10年</p>
                        </td>
                    </tr>

                    <tr>
                        <th class="fixed-column">対応<br>エリア</th>
                        <td class="data-cell rank-1">
                            <div class="double-circle"></div>
                            <p class="bold-font">東京都・神奈川県<br>埼玉県・千葉県</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font"><span class="bold-font">全国</span><br>※一部地域を除く</p>
                        </td>
                        <td class="data-cell">
                            <div class="double-circle"></div>
                            <p class="bold-font">大阪・奈良<br>和歌山・京都</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">関東・関西<br>東海</p>
                        </td>
                        <td class="data-cell">
                            <div class="circle"></div>
                            <p class="bold-font">一部エリアのみ</p>
                        </td>
                    </tr>

                    <tr>
                        <th class="fixed-column cta-cell">公式<br>サイト</th>
                        <td class="data-cell rank-1" style="border-bottom: 2px solid red;">
                            <a :href="affiliateLink" target="_blank" class="site-button" rel="nofollow noopener" @click="affClick">無料見積もり</a>
                        </td>
                        <td class="data-cell btn">
                            <a href="https://www.rentracks.jp/adx/r.html?idx=0.59243.389260.11327.16166&dna=181935" target="_blank" class="site-button">無料見積もり</a>
                        </td>
                        <td class="data-cell btn">
                            <a href="https://chikaramoti.co.jp/" target="_blank" class="site-button">無料見積もり</a>
                        </td>
                        <td class="data-cell btn">
                            <a href="https://lp.machikado-sodan.com/ab/XpBiwJMXRLixOgatw" target="_blank" class="site-button">無料見積もり</a>
                        </td>
                        <td class="data-cell btn">
                            <a href="https://adtech-service-co.com/" target="_blank" class="site-button">無料見積もり</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { makeAffiliateUrl2 } from '@/utils/aff.js'
import { affClick } from '../../utils/affClick.js';
export default {
    name: 'vendorTable',
    mounted() {
        const root = this.$el;
        const wrapper = root.querySelector('.table-wrapper');
        const hint = root.querySelector('.scroll-text');
        if (!wrapper || !hint) return;

        this.__scrollHintDismissed__ = false;

        const updateHint = () => {
            const overflowing = wrapper.scrollWidth > wrapper.clientWidth;
            if (!overflowing || this.__scrollHintDismissed__) {
                hint.classList.add('is-hidden');
                return;
            }
            if (wrapper.scrollLeft > 8) {
                this.__scrollHintDismissed__ = true;
                hint.classList.add('is-hidden');
                return;
            }
            hint.classList.remove('is-hidden');
        };

        updateHint();

        this.__scrollHintHandler__ = updateHint;
        this.__scrollHintTarget__ = wrapper;

        wrapper.addEventListener('scroll', updateHint, { passive: true });
        wrapper.addEventListener('wheel', updateHint, { passive: true });
        wrapper.addEventListener('touchstart', updateHint, { passive: true });
        wrapper.addEventListener('touchmove', updateHint, { passive: true });
        wrapper.addEventListener('keydown', updateHint);

        let rafId = null;
        const rafLoop = () => {
            updateHint();
            rafId = requestAnimationFrame(rafLoop);
        };
        rafId = requestAnimationFrame(rafLoop);
        this.__scrollHintRaf__ = rafId;

        if (wrapper.scrollWidth <= wrapper.clientWidth) {
            hint.classList.add('is-hidden');
        }
    },
    beforeUnmount() {
        const wrapper = this.__scrollHintTarget__;
        const updateHint = this.__scrollHintHandler__;
        if (wrapper && updateHint) {
            wrapper.removeEventListener('scroll', updateHint);
            wrapper.removeEventListener('wheel', updateHint);
            wrapper.removeEventListener('touchstart', updateHint);
            wrapper.removeEventListener('touchmove', updateHint);
            wrapper.removeEventListener('keydown', updateHint);
        }
        if (this.__scrollHintRaf__) {
            cancelAnimationFrame(this.__scrollHintRaf__);
        }
    },
    data() {
        return {
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth() + 1
        };
    },
    computed: {
        affiliateLink() {
            return makeAffiliateUrl2();
        }
    },
    methods: {
        affClick
    }
};
</script>

<style scoped>
/* ------- ベース ------- */
.annotation-box {
    text-align: left;
    font-size: 10px;
    margin: 0;
    padding: 0;
    color: gray;
}

.annotation-box p {
    margin: 0;
    padding-left: 5px;
    padding-top: 5px;
}

.table-container {
    width: 100%;
    box-sizing: border-box;
    position: relative;
}

.table-wrapper {
    overflow-x: auto;
    white-space: nowrap;
}

.vendor-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border-spacing: 0;
    border: 1px solid #ccc;
    box-sizing: border-box;
    min-width: 600px;
}

.header-cell {
    background: #f0f8ff;
    border: 1px solid #ccc;
    font-weight: bold;
    vertical-align: top;
    padding: 5px;
}

/* 見出し列（左端） */
.fixed-column {
    border-bottom: 1px solid #ccc;
    width: 100px;
    /* PCデフォルト */
    background: #848282;
    font-size: 13px;
    font-weight: bold;
    position: sticky;
    left: 0;
    z-index: 999;
    box-shadow: 2px 0 5px rgba(0, 0, 0, .1);
    color: #fff;
}

.vendor-column:not(.fixed-column) {
    width: 150px;
    vertical-align: top;
    position: relative;
    white-space: normal;
}

.data-cell:not(.fixed-column) {
    width: 150px;
}

.vendor-column.vendor-1 {
    background: #fffacd;
    border-left: 2px solid red;
    border-right: 2px solid red;
    border-top: 2px solid red;
}

.vendor-column.vendor-1 .ranking-badge {
    background: #ffc107;
}

.vendor-name {
    padding: 0;
    margin: 0;
    font-size: 0.8rem;
}

.vendor-info,
.vendor-info p,
.vendor-info a {
    white-space: normal;
    word-break: break-all;
}

.vendor-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}

.vendor-image {
    max-width: 100%;
    height: auto;
}

.data-cell {
    background: #fff;
    border: 1px solid #ccc;
    text-align: center;
    padding: 12px;
    vertical-align: middle;
    white-space: normal;
}

.vendor-table tbody tr>.data-cell:nth-child(2) {
    border-left: 2px solid red;
    border-right: 2px solid red;
}

.ranking-badge {
    padding: 0;
    margin: 0;
    color: #fff;
}

.rank-1 {
    background: #fffacd;
}

.ranking-badge.no-1 {
    background: #ff8c00;
}

.ranking-badge.no-2 {
    background: #aba4a4;
}

.ranking-badge.no-3 {
    background: #a0522d;
}

.ranking-badge.no-4 {
    background: #d4855f;
}

.ranking-badge.no-5 {
    background: #e4bdaa;
}

.data-cell p {
    margin-top: 0;
    margin-bottom: 0;
}

.gray-triangle {
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid #777;
}

.btn {
    padding: 20px;
}

td {
    font-weight: 600;
    font-size: 14px;
}

.hoshi {
    color: #ebd515;
    font-size: 20px;
}

.normal {
    font-size: 20px;
}

.number {
    font-weight: bold;
    font-size: 20px;
}

.point {
    font-weight: 700;
    font-size: 15px;
}

.vendor-info img {
    width: 90%;
    padding-top: 10px;
}

.site-button {
    --btn-bg: #ff7a00;
    --btn-bg-dark: #e96e00;
    --btn-bg-grad-top: #ffa043;
    --btn-radius: 999px;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: linear-gradient(180deg, var(--btn-bg-grad-top) 0%, var(--btn-bg) 40%, var(--btn-bg) 100%);
    color: #fff;
    border: 2px solid var(--btn-bg-dark);
    padding: 12px 20px;
    border-radius: var(--btn-radius);
    cursor: pointer;
    text-decoration: none;
    line-height: 1;
    letter-spacing: .02em;
    box-shadow: var(--btn-shadow);
    transition: transform .08s ease, box-shadow .2s ease, background .2s ease, filter .2s ease;
    position: relative;
    isolation: isolate;
}

.site-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 20px rgba(233, 110, 0, .28);
    filter: brightness(1.02);
}

.site-button:active {
    transform: translateY(0);
    box-shadow: 0 5px 10px rgba(233, 110, 0, .22);
}

.site-button:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba(255, 122, 0, .9);
}

.vendor-table .data-cell .site-button {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 10px 14px;
    font-size: clamp(12px, 2.6vw, 14px);
    line-height: 1.1;
}

.scroll-text {
    padding-right: 10px;
    margin: 0;
    text-align: right;
    font-size: 18px;
    background: #eef5ff;
    /* display: none; */
}

.scroll-text {
    transition: opacity .25s ease, visibility .25s ease;
    will-change: opacity, visibility;
}

.scroll-text.is-hidden {
    opacity: 0 !important;
    visibility: hidden !important;
}

@keyframes blinking {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.blink {
    animation: blinking 1s ease-in-out infinite alternate;
}

.table-hader-title h2 {
    background-color: #3f51b5;
    color: #fff;
    display: inline-block;
    padding: 20px;
}

.table-hader-title {
    background: #eef5ff;
}

@media (max-width:600px) {
    /* .vendor-table {
        --fixed-w: 100px;
        --col-w: 200px;
        min-width: calc(var(--fixed-w) + 4 * var(--col-w));
    } */

    /* ヘッダー列幅 */
    .vendor-table .header-cell.fixed-column,
    .vendor-table .fixed-column {
        width: 70px;
    }

    .vendor-table .vendor-column.vendor-1,
    .vendor-table .vendor-column.vendor-2,
    .vendor-table .vendor-column.vendor-3,
    .vendor-table .vendor-column.vendor-4,
    .vendor-table .vendor-column.vendor-5 {
        width: 100px;
    }

    .vendor-table tbody .fixed-column {
        width: 100px;
    }

    .vendor-table tbody td:nth-child(2),
    .vendor-table tbody td:nth-child(3),
    .vendor-table tbody td:nth-child(4),
    .vendor-table tbody td:nth-child(5),
    .vendor-table tbody td:nth-child(6) {
        width: 100px;
    }

    .vendor-name {
        font-size: .85rem;
    }

    .vendor-table .data-cell {
        padding: 5px;
    }
}

@media (max-width:480px) {
    .vendor-table {
        --fixed-w: 72px;
        --col-w: 164px;
        min-width: calc(var(--fixed-w) + 5 * var(--col-w));
    }

    .vendor-table .vendor-column:not(.fixed-column),
    .vendor-table .data-cell:not(.fixed-column) {
        width: auto;
    }
}

@media (max-width:600px) {
    .scroll-text {
        display: block;
        font-size: 1rem;
    }

    .ranking-badge span {
        font-size: 1rem;
    }

    .vendor-info p {
        font-size: .8rem;
    }

    .annotation-box p {
        font-size: .7rem;
    }

    .number span,
    .hoshi,
    .normal {
        font-size: 1.1rem;
    }

    .number span {
        font-size: 1.3rem;
    }

    .cta-cell {
        padding: 15px;
    }

    .scroll-text {
        padding: 8px 12px;
        gap: 6px;
        box-shadow: 0 4px 14px rgba(0, 0, 0, .16);
    }

    .scroll-text .blink {
        font-size: 0.9rem;
    }

    .table-container .scroll-text {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: inline-flex;
        align-items: center;
        gap: 8px;
        border-radius: 5px;
        background: #3f51b5e8;
        color: #fff;
        font-weight: 700;
        z-index: 1000;
        pointer-events: none;
        white-space: nowrap;
        padding: 20px 30px;
    }

    .vendor-table .data-cell .site-button {
        padding: 12px 5px;
        font-size: 1rem;
        margin: 10px 0;
    }
}

@media (max-width:480px) {
    .ranking-badge span {
        font-size: 1rem;
    }

    .vendor-info p {
        font-size: .85rem;
    }

    .annotation-box p {
        font-size: .7rem;
    }

    .number span,
    .hoshi,
    .normal {
        font-size: 1.2rem;
    }

    .number span {
        font-size: 1.5rem;
    }

    .cta-cell {
        padding: 15px;
    }

    .scroll-text {
        font-size: 0.8rem;
        padding-top: 10px;
    }

    .table-hader-title h2 {
        font-size: 1.3rem;
        padding: 20px 40px;
        border-radius: 10px;
    }
}

.annotation-box {
    margin-bottom: 30px;
}
</style>